// @ts-nocheck
import { GridItem } from "@insite/mobius/index";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { css } from "styled-components";

interface Props {
    doubleSized?: boolean;
    children: React.ReactNode;
}
const ReportingFilterGridItem: React.FC<Props> = ({ doubleSized = false, children }) => {
    return (
        <GridItem
            width={doubleSized ? [12, 12, 6, 6, 6] : [12, 12, 3, 3, 3]}
            css={css`
                max-width: ${pxToRem(342)} !important;
            `}
        >
            {children}
        </GridItem>
    );
};

export default ReportingFilterGridItem;
